<template>
  <div class="frame" :class="{'frame-selected': selected}">
    <div class="circle">
      <img class="image" :src="icon" />
    </div>
    <div class="text">{{label}}</div>
  </div>
</template>

<script>
export default {
  name: 'LikeIconFour',
  props: {
    selected: {type: Boolean, required: false, default: false},
    label: {type: String, required: true},
    icon: {required: true},
  }
}
</script>

<style lang="stylus" scoped>
.frame
  display flex
  flex-direction column
  width 80px
  height 80px
  padding 8px 0 0 0
  border-radius 16px
  background: #EAE9E9
  justify-content center
  align-items center

.frame-selected
  background: #FFD5BF;

.circle
  padding 4px
  width 48px
  height 48px
  border-radius 24px
  background: #F8F8F8;

.image
  width 40px
  height 40px

.text
  width 100%
  height 24px
  line-height 24px
  text-align center
  vertical-align middle
  font-size 12px
  font-weight 700
  color: #494645;

</style>